export const OBJETIVOSLANDING = ['Reunion Grupal', 'Reunion Individual']

export const ESTADOSLANDINGS = ['Publicada', 'No publicada', 'Archivada']